module.exports = __webpack_public_path__ + "static/Cover-365b378214703db2bab9d24a073f6ed9.jpg";